module.exports = __webpack_public_path__ + "static/media/domesticHotWater.77fc06a0.png";